"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _commonMedia = require("@mmc/common-media");
var _discoverMitsubishi = _interopRequireDefault(require("../styles/discover-mitsubishi.css"));
var BackgroundImage = function BackgroundImage(_ref) {
  var imageData = _ref.imageData,
    theme = _ref.theme;
  var imageWidth = 2160;
  return /*#__PURE__*/_react["default"].createElement(_commonMedia.CommonMedia, {
    theme: theme,
    mediaClasses: [_discoverMitsubishi["default"].backgroundImage],
    size: imageWidth,
    sizes: "(min-width: 768px) 80vw, 100vw",
    image: imageData
  });
};
var _default = BackgroundImage;
exports["default"] = _default;